import React from "react";
import PropTypes from "prop-types";
import TriggerSignUpSFLB from "../save-for-later-button/trigger-sign-up-SFLB";
import ToggleSaveSFLB from "../save-for-later-button/toggle-save-SFLB";

function SaveForLaterButton({ isLoggedIn, productId }) {
    if (isLoggedIn) {
        return <ToggleSaveSFLB productId={productId} />;
    } else {
        return <TriggerSignUpSFLB />;
    }
}

export default SaveForLaterButton;

SaveForLaterButton.propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
    productId: PropTypes.number.isRequired
};
